/**
 * Basic Registration container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import registrationActions from './actions';
import BasicRegistrationFormV2 from '../../Components/BasicRegistration/BasicRegistrationFormV2';
import {
  errorSelector,
  loadingSelector,
  tokenSelector,
  validAccessTokenSelector,
} from './selectors';
import { loggedInSelector } from '../App/selectors';
import promisifyActions from '../../Lib/Utils/promisify-actions';

const { signup, verifyInviteToken } = registrationActions;

function InfluencerBasicRegistration(props) {
  return <BasicRegistrationFormV2 {...props} influencer />;
}

/**
 * The basic registration properties to be provided to the admin console component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  validAccessToken: validAccessTokenSelector(state),
  loading: loadingSelector(state),
  isLoggedIn: loggedInSelector(state),
  token: tokenSelector(state),
  error: errorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch basic registration actions
 */
const mapDispatchToProps = (dispatch) => ({
  signup: (formData) => dispatch(signup(formData)),
  verifyInviteToken: (token) => dispatch(verifyInviteToken(token)),
});

/**
 * Connects state to the basic registration component
 *
 * @param {object} mapStateToProps data object to become props for the basic registration component
 * @param {object} mapDispatchToProps actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )(InfluencerBasicRegistration),
);
